import { reactive, watch } from "vue";

export function useScreenRuler({ screenRulerRef, screenRulerTopRef, screenRulerBottomRef, lastMouseRef, isTouchDevice, refreshSnapshot }) {
    const state = reactive({
        isScreenRulerActive: false,
        screenRulerColor: "#85898D",
        screenRulerHeight: 80,
        screenRulerHeightStep: 5,
        isScreenRulerSettingsMenuOpen: false,
    });

    function updateScreenRuler() {
        const space = state.screenRulerHeight / 2;
        const hTop = lastMouseRef.value.y - space;
        const hBottom = window.outerHeight - (hTop + space * 2);
        const tBottom = lastMouseRef.value.y + space;
        if (screenRulerTopRef.value) screenRulerTopRef.value.style.height = hTop + "px";
        if (screenRulerBottomRef.value) {
            screenRulerBottomRef.value.style.height = hBottom + "px";
            screenRulerBottomRef.value.style.top = tBottom + "px";
        }
    }

    function listenerScreenRuler(e) {
        const clientX = isTouchDevice.value ? e.touches[0].clientX : e.clientX;
        const clientY = isTouchDevice.value ? e.touches[0].clientY : e.clientY;
        if (isTouchDevice.value) {
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const threshold = windowWidth * 0.7;
            if (clientX < threshold) {
                e.preventDefault();
                document.body.style.overflowY = "hidden";
                lastMouseRef.value = { x: clientX, y: clientY };
            } else {
                document.body.style.overflowY = "auto";
            }
        } else {
            lastMouseRef.value = { x: clientX, y: clientY };
        }
        updateScreenRuler();
    }

    function manageScreenRuler() {
        const eventName = isTouchDevice.value ? "touchmove" : "mousemove";
        if (state.isScreenRulerActive) {
            if (screenRulerRef.value) screenRulerRef.value.style.display = "block";
            lastMouseRef.value = { x: 0, y: window.innerHeight / 2 };
            document.addEventListener(eventName, listenerScreenRuler);
            updateScreenRuler();
        } else {
            if (screenRulerRef.value) screenRulerRef.value.style.display = "none";
            document.removeEventListener(eventName, listenerScreenRuler);
        }
    }

    function toggleScreenRuler() {
        state.isScreenRulerActive = !state.isScreenRulerActive;
        refreshSnapshot(120);
    }

    function checkToggleScreenRuler() {
        if (!state.isScreenRulerActive) toggleScreenRuler();
    }

    function toggleScreenRulerSettingsMenu() {
        state.isScreenRulerSettingsMenuOpen = !state.isScreenRulerSettingsMenuOpen;
        refreshSnapshot(380);
    }

    function changeScreenRulerHeight(type) {
        checkToggleScreenRuler();
        if (type === "minus" && state.screenRulerHeight > state.screenRulerHeightStep) {
            state.screenRulerHeight -= state.screenRulerHeightStep;
        }
        if (type === "more") {
            state.screenRulerHeight += state.screenRulerHeightStep;
        }
        refreshSnapshot(120);
    }

    function reset() {
        state.isScreenRulerActive = false;
        state.isScreenRulerSettingsMenuOpen = false;
        state.screenRulerColor = "#85898D";
        state.screenRulerHeight = 80;
    }

    function applyFromProfile(entry) {
        if (entry.isScreenRulerActive) state.isScreenRulerActive = true;
        if (entry.screenRulerColor) state.screenRulerColor = entry.screenRulerColor;
        if (entry.screenRulerHeight) state.screenRulerHeight = entry.screenRulerHeight;
    }

    watch(
        () => state.isScreenRulerActive,
        (active) => {
            if (!active) state.isScreenRulerSettingsMenuOpen = false;
            manageScreenRuler();
        }
    );

    watch(
        () => state.screenRulerColor,
        (color) => {
            if (screenRulerRef.value) screenRulerRef.value.style.backgroundColor = color;
        }
    );

    watch(
        () => state.screenRulerHeight,
        () => updateScreenRuler()
    );

    return {
        state,
        updateScreenRuler,
        listenerScreenRuler,
        manageScreenRuler,
        toggleScreenRuler,
        checkToggleScreenRuler,
        toggleScreenRulerSettingsMenu,
        changeScreenRulerHeight,
        reset,
        applyFromProfile,
    };
}
